import { AuditActions } from 'src/types';
import { DateFormats, formatDate } from 'src/utils/time';
import { AuditEntry } from '../CaseAuditLog';

const dateForAuditEntry = (audit: AuditEntry | undefined) =>
  audit?.createdAt
    ? formatDate(audit.createdAt, DateFormats.YYYY_MM_DD)
    : undefined;

export const deduplicateCreateMessageAuditEntries = (
  auditEntries: AuditEntry[],
) => {
  let currentDay: string | undefined = undefined;
  let managerMessageOnCurrentDay = false;
  let reporterMessageOnCurrentDay = false;

  const filteredAuditLog = auditEntries.filter((audit: AuditEntry) => {
    if (audit.action !== AuditActions.CREATE_MESSAGE) {
      return true;
    }

    const auditDate = dateForAuditEntry(audit);

    if (auditDate !== currentDay) {
      managerMessageOnCurrentDay = false;
      reporterMessageOnCurrentDay = false;
      currentDay = auditDate;
    }

    const isCaseManagerMessage = audit.DescriptiveText.includes('case manager');

    if (isCaseManagerMessage && !managerMessageOnCurrentDay) {
      managerMessageOnCurrentDay = true;
      return true;
    }

    if (!isCaseManagerMessage && !reporterMessageOnCurrentDay) {
      reporterMessageOnCurrentDay = true;
      return true;
    }

    return false;
  });

  return filteredAuditLog;
};
